import React, { createContext, useState, useContext, ReactNode, useMemo } from 'react';

interface ErrorContextType {
    showError: (title: string, message: string, statusCode: string) => void;
    hideError: () => void;
    error: {
        title: string;
        message: string;
        statusCode: string;
    } | null;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export const ErrorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [error, setError] = useState<{ title: string; message: string; statusCode: string } | null>(null);

    const showError = (title: string, message: string, statusCode: string) => {
        setError({ title, message, statusCode });
    };

    const hideError = () => {
        setError(null);
    };

    const errorContextObj = useMemo(() => ({ showError, hideError, error }), [showError, hideError, error]);

    return <ErrorContext.Provider value={errorContextObj}>{children}</ErrorContext.Provider>;
};

export const useError = () => {
    const context = useContext(ErrorContext);
    if (context === undefined) {
        throw new Error('useError must be used within an ErrorProvider');
    }
    return context;
};
